export const getParentCategory = '/category/get-parent-category';
/** Admin list (parents/children, includes inactive). Public mobile list remains GET /category/ */
export const getCategoryAdmin = '/category/admin';
export const getCategory = '/category/';
export const getCategoryDetail = '/category/';
export const addCategory = '/category/add-category';
export const addParentCategory = '/category/add-parent-category';
export const updateCategory = '/category/';
export const deleteCategory = '/category/';
export const updateTopCategory = '/category/top-category';
export const updateCategoryStatus = '/category/update-status/';
export const comingSoonCategoryStatus = '/category/coming-soon';
